window.__productFormCartCache = window.__productFormCartCache || {
 data: null,
 promise: null,
 timestamp: 0,
};

function getProductFormCartDataForSizeWarning(force = false) {
 const cache = window.__productFormCartCache;
 const now = Date.now();
 const cacheTtl = 3000;

 if (!force && cache.data && now - cache.timestamp < cacheTtl) {
  return Promise.resolve(cache.data);
 }

 if (!force && cache.promise) {
  return cache.promise;
 }

 cache.promise = fetch(`${routes.cart_url}.js`)
  .then((response) => response.json())
  .then((cartData) => {
   cache.data = cartData;
   cache.timestamp = Date.now();
   return cartData;
  })
  .finally(() => {
   cache.promise = null;
  });

 return cache.promise;
}

function clearProductFormCartDataCache() {
 const cache = window.__productFormCartCache;
 cache.data = null;
 cache.promise = null;
 cache.timestamp = 0;
}

if (!customElements.get("product-form")) {
 customElements.define(
  "product-form",
  class ProductForm extends HTMLElement {
   constructor() {
    super();

    this.form = this.querySelector("form");
    this.cart =
     document.querySelector("cart-notification") ||
     document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');

    if (this.form) {
     this.form.querySelector("[name=id]").disabled = false;
     this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    } else {
     this.form_simulation = this.querySelector(".form-simulation");

     this.form_simulation.querySelector("[name=id]").disabled = false;
     this.submitButton.addEventListener(
      "click",
      this.onSubmitHandler.bind(this),
     );
    }

    if (document.querySelector("cart-drawer"))
     this.submitButton.setAttribute("aria-haspopup", "dialog");

    this.hideErrors = this.dataset.hideErrors === "true";
    this.boundSelectionChangeHandler = this.onSelectionChange.bind(this);
   }

  connectedCallback() {

   // Ensure first color is selected by default if none is selected
   window.requestAnimationFrame(() => {
     const activeForm = this.form || this.form_simulation;
     if (activeForm) {
       const colorSelect = activeForm.querySelector('select[name="Color"], select[name="Farbe"]');
       if (colorSelect && colorSelect.selectedIndex === -1 && colorSelect.options.length > 0) {
         colorSelect.selectedIndex = 0;
         colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
       }
     }
   });

   this.addEventListener("change", this.boundSelectionChangeHandler);
   this.refreshInlineSizeMismatchWarning();
   this.scheduleInitialInlineWarningRefresh();

   // Always re-check warning on page show/visibility (e.g. after navigating back from cart)
   this._boundVisibilityHandler = () => this.refreshInlineSizeMismatchWarning();
   window.addEventListener('pageshow', this._boundVisibilityHandler);
   document.addEventListener('visibilitychange', this._boundVisibilityHandler);

   // Listen for cart updates
   this._boundCartUpdateHandler = () => this.refreshInlineSizeMismatchWarning();
   window.addEventListener('cart-update', this._boundCartUpdateHandler);
  }

  disconnectedCallback() {
   this.removeEventListener("change", this.boundSelectionChangeHandler);

    window.removeEventListener('pageshow', this._boundVisibilityHandler);
    document.removeEventListener('visibilitychange', this._boundVisibilityHandler);
    window.removeEventListener('cart-update', this._boundCartUpdateHandler);
  }

  isProductPageForm() {
   if (document.body.classList.contains("template-product")) return true;
   if (this.closest("main-product")) return true;
   return false;
  }

  getOrCreateInlineSizeWarningElement() {
   if (!this.isProductPageForm()) return null;

   let warningElement = this.querySelector(".product-size-warning");
   if (warningElement) return warningElement;

   const buttonsWrapper = this.querySelector(".product-form__buttons");
   if (!buttonsWrapper) return null;

   warningElement = document.createElement("div");
   warningElement.className = "product-size-warning mixed-size-warning";
   warningElement.style.display = "none";
   warningElement.innerHTML = `
    <div class="alert-warning-icon">
      <svg
        class="svg-icon"
        style="vertical-align: middle;fill: currentColor;overflow: hidden;"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
        <path d="M512 688m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z" />
        <path d="M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" />
      </svg>
    </div>
    <div class="alert-warning-title">Größencheck</div>
    <div class="alert-warning-text"></div>
   `;

   buttonsWrapper.prepend(warningElement);
   return warningElement;
  }

  setInlineSizeWarningMessage(message) {
   const warningElement = this.getOrCreateInlineSizeWarningElement();
   if (!warningElement) return;

   const warningTextElement = warningElement.querySelector(".alert-warning-text");
   if (warningTextElement) {
    warningTextElement.textContent = message || "";
   }

   warningElement.style.display = message ? "flex" : "none";
  }

  formatInlineWarningMessage(message) {
   if (!message) return "";
   return message;
  }

  onSelectionChange() {
   this.refreshInlineSizeMismatchWarning();
   window.requestAnimationFrame(() => {
    this.refreshInlineSizeMismatchWarning();
   });
  }

  scheduleInitialInlineWarningRefresh() {
   // Some pages hydrate variant/cart scripts after this component connects.
   // Re-check briefly so the warning is visible immediately on first load.
   const retryDelays = [0, 120, 300, 700, 1200];
   retryDelays.forEach((delay) => {
    window.setTimeout(() => {
     this.refreshInlineSizeMismatchWarning();
    }, delay);
   });
  }

  async refreshInlineSizeMismatchWarning() {
   if (!this.isProductPageForm()) return;

   const cartSizeGuard = window.SheepiCartSizeGuard;
   if (!cartSizeGuard || typeof cartSizeGuard.buildProspectiveMismatchMessage !== "function") {
    this.setInlineSizeWarningMessage("");
    return;
   }

   const activeForm = this.form || this.form_simulation;
   if (!activeForm) return;

   // Wait until product options/variant selection is stable
   const colorSelect = activeForm.querySelector('select[name="Color"], select[name="Farbe"]');
   const sizeSelect = activeForm.querySelector('select[name="Size"], select[name="Größe"], select[name="Groesse"]');
   if ((colorSelect && colorSelect.selectedIndex === -1) || (sizeSelect && sizeSelect.selectedIndex === -1)) {
     this.setInlineSizeWarningMessage("");
     return;
   }

   const formData = new FormData(activeForm);
   const variantId = this.resolveSelectedVariantId(formData);

   const prospectiveLine = {
    productTitle: this.resolveProductTitle(),
    productType: this.resolveProductType(),
    size: this.resolveSelectedVariantTitle(variantId),
   };

   if (!prospectiveLine.productTitle || !prospectiveLine.size) {
    this.setInlineSizeWarningMessage("");
    return;
   }

   try {
    const cartData = await getProductFormCartDataForSizeWarning();
    const mismatchMessage = cartSizeGuard.buildProspectiveMismatchMessage(cartData?.items || [], prospectiveLine);
    this.setInlineSizeWarningMessage(this.formatInlineWarningMessage(mismatchMessage));
   } catch (error) {
    console.error(error);
    this.setInlineSizeWarningMessage("");
   }
  }

  resolveProductTitle() {
   if (this.dataset.productTitle) return this.dataset.productTitle;

   const stickyTitle = this.querySelector("h5");
   if (stickyTitle && stickyTitle.textContent) return stickyTitle.textContent.trim();

   const mainTitle = document.querySelector(".product__title h1");
   if (mainTitle && mainTitle.textContent) return mainTitle.textContent.trim();

   return "";
  }

  resolveProductType() {
   if (this.dataset.productType) return this.dataset.productType;
   return "";
  }

  resolveSelectedVariantId(formData) {
   const selectedId = Number(formData.get("id"));
   if (Number.isFinite(selectedId) && selectedId > 0) return selectedId;
   return null;
  }

  getRelatedVariantSelects() {
   const sectionId = this.dataset.sectionId;
   if (!sectionId) return null;

   const scopedSelector = `variant-selects[data-section="${sectionId}"]`;
   const sectionRoot = this.closest("section");
   return (
    sectionRoot?.querySelector(scopedSelector) ||
    document.querySelector(scopedSelector)
   );
  }

  resolveVariantFromPickers() {
   const variantSelects = this.getRelatedVariantSelects();
   if (!variantSelects) return null;

   if (variantSelects.currentVariant) return variantSelects.currentVariant;

   const variantsJsonNode = variantSelects.querySelector('script[type="application/json"]');
   if (!variantsJsonNode?.textContent) return null;

   const selectedOptions = Array.from(
    variantSelects.querySelectorAll("select, fieldset"),
    (element) => {
     if (element.tagName === "SELECT") return element.value;
     if (element.tagName === "FIELDSET") {
      return Array.from(element.querySelectorAll('input[type="radio"]')).find(
       (radio) => radio.checked,
      )?.value;
     }
     return undefined;
    },
   );

   if (selectedOptions.some((option) => option == null || option === "")) {
    return null;
   }

   try {
    const variants = JSON.parse(variantsJsonNode.textContent);
    return (
     variants.find((variant) =>
      variant.options.every((optionValue, index) => optionValue === selectedOptions[index]),
     ) || null
    );
   } catch (error) {
    console.error(error);
    return null;
   }
  }

  resolveSelectedVariantTitle(variantId) {
    if (!variantId) return this.resolveSelectedSizeFromOptionInputs();

   const selectInput = (this.form || this.form_simulation)?.querySelector('select[name="id"]');
   if (selectInput) {
    const selectedOption = selectInput.options[selectInput.selectedIndex];
    if (selectedOption && selectedOption.textContent) {
     return selectedOption.textContent.trim();
    }
   }

   const sectionId = this.dataset.sectionId;
   const sectionSelector = sectionId ? `variant-selects[data-section="${sectionId}"]` : "variant-selects";
   const variantSelects = this.closest("section")?.querySelector(sectionSelector) || document.querySelector(sectionSelector);
   const variantsJsonNode = variantSelects?.querySelector('script[type="application/json"]');
   if (!variantsJsonNode || !variantsJsonNode.textContent) return "";

   try {
    const variants = JSON.parse(variantsJsonNode.textContent);
    const selectedVariant = variants.find((variant) => Number(variant.id) === Number(variantId));
    return selectedVariant?.title || this.resolveSelectedSizeFromOptionInputs();
   } catch (error) {
    console.error(error);
    return this.resolveSelectedSizeFromOptionInputs();
   }
  }

  resolveSelectedSizeFromOptionInputs() {
   const activeForm = this.form || this.form_simulation;
   if (!activeForm) return "";

   const sizeRegex = /(\d{1,3})\s*[xX]\s*(\d{1,3})/;

   const selectedRadio = activeForm.querySelector('input[type="radio"]:checked');
   if (selectedRadio && sizeRegex.test(selectedRadio.value || "")) {
    return selectedRadio.value;
   }

   const selectedOptions = Array.from(activeForm.querySelectorAll("select")).map((selectElement) => {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    return selectedOption?.textContent || selectedOption?.value || selectElement.value || "";
   });

   const matchingOption = selectedOptions.find((optionValue) => sizeRegex.test(optionValue));
   if (matchingOption) return matchingOption;

   const checkedInputs = Array.from(activeForm.querySelectorAll('input[type="radio"]:checked')).map((input) => input.value || "");
   const matchingInput = checkedInputs.find((inputValue) => sizeRegex.test(inputValue));
   if (matchingInput) return matchingInput;

   return "";
  }

  async shouldProceedForSizeMismatch(formData) {
   const cartSizeGuard = window.SheepiCartSizeGuard;
   if (!cartSizeGuard || typeof cartSizeGuard.buildProspectiveMismatchMessage !== "function") {
    return true;
   }

   const variantId = this.resolveSelectedVariantId(formData);
   const prospectiveLine = {
    productTitle: this.resolveProductTitle(),
    productType: this.resolveProductType(),
    size: this.resolveSelectedVariantTitle(variantId),
   };

   if (!prospectiveLine.productTitle || !prospectiveLine.size) {
    return true;
   }

   try {
    const cartData = await getProductFormCartDataForSizeWarning();
    const mismatchMessage = cartSizeGuard.buildProspectiveMismatchMessage(cartData?.items || [], prospectiveLine);
    this.setInlineSizeWarningMessage(this.formatInlineWarningMessage(mismatchMessage));

    return true;
   } catch (error) {
    console.error(error);
    return true;
   }
  }

  async onSubmitHandler(evt) {
   evt.preventDefault();
   if (this.submitButton.getAttribute("aria-disabled") === "true") return;

   const config = fetchConfig("javascript");
   config.headers["X-Requested-With"] = "XMLHttpRequest";
   delete config.headers["Content-Type"];
   let formData = new FormData();

   if (this.form) {
    formData = new FormData(this.form);
   } else {
    const tempForm = document.createElement("form");
    tempForm.innerHTML = this.form_simulation.innerHTML;
    formData = new FormData(tempForm);
   }

    const selectedVariant = this.resolveVariantFromPickers();
    if (selectedVariant?.id) {
     formData.set("id", String(selectedVariant.id));
      const liveVariantInput = (this.form || this.form_simulation)?.querySelector('[name="id"]');
      if (liveVariantInput) {
       liveVariantInput.value = String(selectedVariant.id);
      }
    }

    if (selectedVariant && selectedVariant.available === false) {
     this.handleErrorMessage(window?.variantStrings?.soldOut || "Sold out");
     return;
    }

   if (this.cart) {
    formData.append(
    "sections",
    this.cart.getSectionsToRender().map((section) => section.id),
    );
    formData.append("sections_url", window.location.pathname);
    if (this.cart.setActiveElement) {
      this.cart.setActiveElement(document.activeElement);
    }
   }

    const shouldProceed = await this.shouldProceedForSizeMismatch(formData);
    if (!shouldProceed) {
     return;
    }

    this.handleErrorMessage();

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");
    this.querySelector(".loading__spinner").classList.remove("hidden");

   config.body = formData;

   fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
    if (response.status) {
     this.handleErrorMessage(response.description);

     const soldOutMessage =
      this.submitButton.querySelector(".sold-out-message");
     if (!soldOutMessage) return;
     this.submitButton.setAttribute("aria-disabled", true);
     this.submitButton.querySelector("span").classList.add("hidden");
     soldOutMessage.classList.remove("hidden");
     this.error = true;
     return;
    } else if (!this.cart) {
     window.location = window.routes.cart_url;
     return;
    }

    this.error = false;
    clearProductFormCartDataCache();
    window.dispatchEvent(new Event("cart-update"));

    const quickAddModal = this.closest("quick-add-modal");
    if (quickAddModal) {
     document.body.addEventListener(
      "modalClosed",
      () => {
      setTimeout(() => {
       this.cart.renderContents(response);
      });
      },
      { once: true },
     );
     quickAddModal.hide(true);
    } else {
     this.cart.renderContents(response);
    }
    })
    .catch((e) => {
    console.error(e);
    })
    .finally(() => {
    this.submitButton.classList.remove("loading");
    if (this.cart && this.cart.classList.contains("is-empty"))
     this.cart.classList.remove("is-empty");
    if (!this.error) this.submitButton.removeAttribute("aria-disabled");
    this.querySelector(".loading__spinner").classList.add("hidden");

    if (this.cart) {
     this.cart.open();
    }
    });
  }

   handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper =
     this.errorMessageWrapper ||
     this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage =
     this.errorMessage ||
     this.errorMessageWrapper.querySelector(".product-form__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
     this.errorMessage.textContent = errorMessage;
    }
   }
  },
 );
}
